// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1zx4B","rightAdornment":"Header_rightAdornment__CQalv"};